<section class="d-flex align-content-center align-items-center py-2" *ngIf="value">
    <mat-progress-bar
      [ngClass]="currentPasswordStrength?.color"
      mode="determinate"
      [value]="currentPasswordStrength?.progressBar"
    >
    </mat-progress-bar>
    <div class="strength-validator"> {{currentPasswordStrength?.description | translate}} </div>
  </section>
  